// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"992f6d6d","667":"b1d8c069","977":"0b68106d"}[chunkId] + ".chunk.js";
};